export default {
  validation: "Dies ist ein Pflichtfeld",
};
